import { reactive, toRefs } from 'vue'
import { db, addDoc, collection, serverTimestamp, storage, ref, uploadBytesResumable, getDownloadURL } from '@/firebase/config'

const data = reactive({
  err: null,
  uploadStatus: null
})
let { err, uploadStatus } = toRefs(data)

// Create file metadata including the content type @type {any} */ image/jpeg
const metadata = {
  contentType: '*'
}

const upload = async (user, fileName, uploadFile) => {
  const storedRef = ref(storage, `/schools/inspire-schools/${user.role}/${user.grade}/${fileName}`)
  const uploadTask = uploadBytesResumable(storedRef, uploadFile, metadata)
  // Listen for state changes, errors, and completion of the upload.
  uploadTask.on('state_changed',
    (snapshot) => {
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      console.log('Upload is ' + progress + '% done')
      uploadStatus = progress + '%'
      switch (snapshot.state) {
        case 'paused':
          console.log('Upload is paused')
          uploadStatus = 'Upload is paused'
          break
        case 'running':
          console.log('Upload is running')
          uploadStatus = 'Upload is running ' + progress + '%'
          break
      }
    },
    (error) => {
      switch (error.code) {
        case 'storage/unauthorized':
          // User doesn't have permission to access the object
          err = error.code
          break
        case 'storage/canceled':
          // User canceled the upload
          err = error.code
          break

          // ...

        case 'storage/unknown':
          // Unknown error occurred, inspect error.serverResponse
          err = error.code
          break
      }
    },
    () => {
      // Upload completed successfully, now we can get the download URL
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        console.log('File available at', downloadURL)
        const post = {
          title: fileName,
          grade: user.grade,
          URL: downloadURL,
          lid: user.user.uid,
          createdAt: serverTimestamp()
        }
        addDoc(collection(db, '/schools/inspire-schools/' + user.grade + '/uploads/' + user.role),
          post)
          .then(() => {})
      })
    }
  )
}
// Call updateUser.js
const useUpload = () => {
  return { uploadStatus, err, upload }
}

export default useUpload
